module.exports = __webpack_public_path__ + "media/Nuits et Jours .86b7d040.mp3";